<template>
  <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
    <template #toolbar>
      <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onClickStampa()"> <font-awesome-icon icon="print" />Stampa</b-button>
    </template>
    <template slot="toolbar-title">
      <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
    </template>
    <template slot="table-body">
      <rsa-paziente-stampe-component ref="cmpPazientiStampeComponent"></rsa-paziente-stampe-component>
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteStampeComponent from "../components/RsaPazienteStampeComponent.vue";
export default {
  props: {
    utente: { type: Object },
  },
  components: {
    SaPageLayout,
    RsaOspiteAnagraficaComponent,
    RsaPazienteStampeComponent,
  },
  data() {
    return {
      idAccettazione: null,
      btnNuovaRichiestaEsameHidden: true,
      btnNuovaRichiestaUscita: true,
      filtro: {},
      btnNewVisible: true,
      pathResource: null,
      pathResourceAccettazione: "/accettazioni",
      linkedit: null,
      linkback: "/rsagestioneospiti",
      showModalLoading: false,
      listKey: 0,
      jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
    };
  },
  mounted() {
    let me = this;
    me.idAccettazione = this.$route.query.idAccettazione;
    me.loadAccettazione();
  },
  methods: {
    loadAccettazione() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
      axios
        .get(link)
        .then((response) => {
          me.jsonData = response.data.data;
          me.$refs.cmpRsaConsensiList.setDati(me.idAccettazione, me.jsonData.codiceStruttura, "NURITY");
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },

    onClickStampa() {
      console.log(this.$refs.cmpPazientiStampeComponent);

      let selected = this.$refs.cmpPazientiStampeComponent.getSelectedStampe();
      selected;
      console.log(this.$refs.cmpPazientiStampeComponent.getSelectedStampe());
    },
  },
};
</script>

<style></style>
